/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetPartnerSettings200ResponseDataInner } from './GetPartnerSettings200ResponseDataInner'
import {
  GetPartnerSettings200ResponseDataInnerFromJSON,
  GetPartnerSettings200ResponseDataInnerFromJSONTyped,
  GetPartnerSettings200ResponseDataInnerToJSON,
} from './GetPartnerSettings200ResponseDataInner'

/**
 *
 * @export
 * @interface GetPartnerSetting200Response
 */
export interface GetPartnerSetting200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetPartnerSetting200Response
   */
  status: boolean
  /**
   *
   * @type {GetPartnerSettings200ResponseDataInner}
   * @memberof GetPartnerSetting200Response
   */
  data: GetPartnerSettings200ResponseDataInner
}

/**
 * Check if a given object implements the GetPartnerSetting200Response interface.
 */
export function instanceOfGetPartnerSetting200Response(
  value: object
): value is GetPartnerSetting200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetPartnerSetting200ResponseFromJSON(
  json: any
): GetPartnerSetting200Response {
  return GetPartnerSetting200ResponseFromJSONTyped(json, false)
}

export function GetPartnerSetting200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPartnerSetting200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: GetPartnerSettings200ResponseDataInnerFromJSON(json['data']),
  }
}

export function GetPartnerSetting200ResponseToJSON(
  value?: GetPartnerSetting200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: GetPartnerSettings200ResponseDataInnerToJSON(value['data']),
  }
}
